<div class="location-picker">
  <label class="location-label" for="chart-create-country">
    {{ text().countryLabel }}
  </label>
  <ng-select
    labelForId="chart-create-country"
    [items]="countries()"
    bindLabel="name"
    bindValue="code"
    [searchable]="true"
    [clearable]="false"
    [ngModel]="selectedCountry()"
    (ngModelChange)="selectCountry($event)"
    [placeholder]="text().countryPlaceholder"
    [ariaLabel]="text().countryAria"
    [ariaLabelDropdown]="text().countryDropdownAria"
    [notFoundText]="text().countryNoResults"
    [loadingText]="text().countryLoading"
  ></ng-select>

  <label class="location-label" for="chart-create-city">
    {{ text().cityLabel }}
  </label>
  <div class="location-city">
    <input
      id="chart-create-city"
      class="form-control"
      type="text"
      [value]="cityQuery()"
      [disabled]="!selectedCountry()"
      [placeholder]="text().cityPlaceholder"
      (input)="onCityInput($any($event.target).value)"
      (blur)="confirmFreeText(cityQuery())"
      [attr.aria-label]="text().cityAria"
    />
    @if (citySuggestions().length) {
      <div class="location-suggestions">
        @for (city of citySuggestions(); track city.name + city.latitude) {
          <button type="button" class="location-suggestion" (click)="selectCity(city)">
            {{ city.name }} <span class="location-suggestion-tz">{{ city.timezone }}</span>
          </button>
        }
      </div>
    }
  </div>

  @if (error(); as message) {
    <p class="location-error" role="alert">{{ message }}</p>
  }
</div>
